import { buildLegalDocumentHtml } from '@/features/auth/components/legal/legal-document-html';

/**
 * Sample Privacy Policy copy rendered in the legal popup. This is placeholder
 * data — swap the body for the production legal text when it is finalised.
 */
export const PRIVACY_POLICY_HTML = buildLegalDocumentHtml(`
    <section>
      <h2>What we collect</h2>
      <ul>
        <li>Name</li>
        <li>Contact information including email address</li>
        <li>Demographic information such as postal code, preferences, and interests</li>
        <li>Other information relevant to customer surveys</li>
      </ul>
      <p>
        For the exhaustive list of cookies we collect see the
        list of cookies we collect
        section.
      </p>
    </section>

    <section>
      <h2>What we do with the information we gather</h2>
      <p>
        We require this information to understand your needs and provide you with a better service,
        and in particular for the following reasons:
      </p>
      <ul>
        <li>Internal record keeping.</li>
        <li>We may use the information to improve our products and services.</li>
        <li>
          We may periodically send promotional emails about new products, special offers or other
          information which we think you may find interesting using the email address which you have
          provided.
        </li>
        <li>
          From time to time, we may also use your information to contact you for market research
          purposes. We may contact you by email, phone, fax or mail. We may use the information to
          customize the website according to your interests.
        </li>
      </ul>
    </section>

    <section>
      <h2>Security</h2>
      <p>
        We are committed to ensuring that your information is secure. In order to prevent
        unauthorised access or disclosure, we have put in place suitable physical, electronic and
        managerial procedures to safeguard and secure the information we collect online.
      </p>
    </section>

    <section>
      <h2>How we use cookies</h2>
      <p>
        A cookie is a small file which asks permission to be placed on your computer's hard drive.
        Once you agree, the file is added and the cookie helps analyse web traffic or lets you know
        when you visit a particular site. Cookies allow web applications to respond to you as an
        individual.
      </p>
      <p>
        We use traffic log cookies to identify which pages are being used. This helps us analyse
        data about web page traffic and improve our app in order to tailor it to customer needs.
        We only use this information for statistical analysis purposes and then the data is removed
        from the system.
      </p>
    </section>

    <section>
      <h2>Controlling your personal information</h2>
      <p>
        You may choose to restrict the collection or use of your personal information at any time.
        If you believe that any information we are holding on you is incorrect or incomplete, please
        contact us at coach@uskidsgolf.com as soon as
        possible. We will promptly correct any information found to be incorrect.
      </p>
      <p class="muted">Last updated: June 2026</p>
    </section>
`);

export default PRIVACY_POLICY_HTML;
